import { render, staticRenderFns, recyclableRender, components } from "./u-transition.vue?vue&type=template&id=8e60ec6e&scoped=true&"
var renderjs
import script from "./u-transition.vue?vue&type=script&lang=js&"
export * from "./u-transition.vue?vue&type=script&lang=js&"
import style0 from "./u-transition.vue?vue&type=style&index=0&id=8e60ec6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e60ec6e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-transition/u-transition.vue"
export default component.exports